export const INITIAL_STATE = "INITIAL_STATE";
export const ADD_SECTION = "ADD_SECTION";
export const ADD_FIELD = "ADD_FIELD";
export const MOVE_SECTION = "MOVE_SECTION";
export const MOVE_FIELD = "MOVE_FIELD";
export const REMOVE_SECTION = "REMOVE_SECTION";
export const REMOVE_FIELD = "REMOVE_FIELD";
export const UPDATE_SECTION_DETAIL = "UPDATE_SECTION_DETAIL";
export const UPDATE_FIELD_DETAIL = "UPDATE_FIELD_DETAIL";
